export const APP_NAME = "POS";
export const APP_VERSION = "2.4.89";

export type AppConfig = {
  apiUrl: string;
  environment: "development" | "staging" | "production";
};

export { apiClient, ApiError, setBaseUrl, getBaseUrl } from "./api/index";
export {
  createQueryClient,
  QueryClientProvider,
  configKeys,
  useProfiles,
  useAccessControl,
  useFieldControl,
  useSidebarConfig,
  useConfigLoaded,
} from "./query/index";
export { useAuthStore } from "./stores/index";
export {
  useModuleAccess,
  useReportAccess,
  useShortcutAccess,
  useIsMdm,
} from "./hooks/use-permissions";
export type {
  ModuleAccessResult,
  ReportAccessResult,
  ShortcutAccessResult,
} from "./hooks/use-permissions";
export {
  AccessControlProvider,
  AccessGate,
  useElementState,
} from "./hooks/use-element-access";
export type {
  AccessControlProviderProps,
  AccessGateProps,
} from "./hooks/use-element-access";
export type {
  AuthUser,
  ActiveStore,
  StoreOption,
  AuthState,
  LoginResponse,
  AppConfigData,
  Profile,
  ParsedProfile,
  AccessControlRule,
  FieldControlRule,
  SidebarItem,
} from "./types/auth";
export {
  useNetworkStatus,
  useSpeedTest,
  checkNetworkNow,
  setPingUrl,
} from "./hooks/use-network-status";
export type { NetworkStatus } from "./hooks/use-network-status";
export { z } from "zod";
export { zodResolver } from "@hookform/resolvers/zod";
